<template>
  <main>
    <router-view/>
  </main>
</template>

<script>
import axios from 'axios';
import LoginTimerService from '@/services/loginTimerService';

export default {
  data() {
    return {
      user: null,
      roles: null,
      selectedLanguage: localStorage.getItem('selectedLanguage') || 'fr', // Default language
      selectedCustomer: localStorage.getItem('parkkingustomerselected'), // Default language
      customerType: localStorage.getItem('parkkingcustomertype'), // Default language
      supportedLanguages: ['en', 'nl', 'fr'], // List of supported languages
      unreadCount: 0,
      unreadCountBookings: 0
    };
  },
  computed: {
    // Compute the current environment
    environment() {
      return process.env.NODE_ENV;
    },
    // Check if the environment is not production
    isNotProduction() {
      return process.env.NODE_ENV !== 'production';
    }
  },
  methods: {
    changeLanguage() {
      // Update the selected language in localStorage
      localStorage.setItem('selectedLanguage', this.selectedLanguage);
      // Update the language in vue-i18n
      this.$i18n.locale = this.selectedLanguage;
    },
    changeCustomer() {
      localStorage.setItem('parkkingcustomerselected', this.selectedCustomer);

      const token = localStorage.getItem('parkkingtoken');
      const instance = axios.create({
        baseURL: this.$baseURL,
        headers: {
          'X-Partner-ID': 3,
          Authorization: `Bearer ${token}`,
          'Customer': localStorage.getItem('parkkingcustomerselected')
        }
      });

      /* Get settings */
      instance.get('customer/type')
        .then(response => {
            this.customerType = response.data.type;
            localStorage.setItem('parkkingcustomertype', response.data.type);

            location.reload();
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            // Handle the error
        });
    },
    setupLoginTimerCheck() {
      setInterval(() => {
        if (LoginTimerService.isInternalUser() && localStorage.getItem('parkkingtoken')) {
          LoginTimerService.checkAndLogoutIfExpired();
        }
      }, 30000);
    },
    setupPageVisibilityCheck() {
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && LoginTimerService.isInternalUser()) {
          setTimeout(() => {
            LoginTimerService.checkAndLogoutIfExpired();
          }, 1000);
        }
      });
    },
    setupCrossTabLogoutSync() {
      window.addEventListener('storage', (event) => {
        if (event.key === 'parkkingusertype' || event.key === 'parkkingtoken') {
          if (event.newValue === null && event.oldValue !== null) {
            const userType = event.oldValue || localStorage.getItem('parkkingusertype');
            const currentUrl = window.location.href;
            const isLogoutPage = currentUrl.includes('logout') || currentUrl.includes('login') || currentUrl.includes('internal');

            if (!isLogoutPage && userType === 'INTERNAL') {
              window.location.href = '/internal';
            }
          }
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    const role = localStorage.getItem('parkkingrole');

    // Check if the current route path contains "/admin"
    if (window.location.href.includes("/admin") && role && role != 1) {
      // Redirect to the home page or any other desired route
      next({ path: "/" });
    } else {
      next();
    }
  },
  mounted() {
    this.setupCrossTabLogoutSync();

    // Function to position the dropdown menu
    const positionDropdownMenu = () => {
        const avatarElement = document.querySelector('.avatar');

        if (avatarElement) {
            // Get the bounding client rect of the avatar element
            const rect = avatarElement.getBoundingClientRect();

            // Calculate the right position from the right side of the screen
            const rightPositionFromRight = window.innerWidth - rect.right;

            const menuDropdown = document.querySelector('.menu.menu-sub.menu-sub-dropdown');

            // Check if the menuDropdown element is found in the DOM
            if (menuDropdown) {
                // Set the top and right positions
                menuDropdown.style.position = 'absolute'; // Ensures it is positioned absolutely
                menuDropdown.style.top = '75px';          // Adjust the top position as needed
                menuDropdown.style.right = rightPositionFromRight + 'px'; // Adjust the right position as needed
            }
        }
    };

    setTimeout(function() {
      positionDropdownMenu();
    }, 1500);
    
    document.addEventListener("DOMContentLoaded", () => {
      const element = document.getElementById('kt_app_wrapper');

      // Call positionDropdownMenu on page load
      positionDropdownMenu();

      // ResizeObserver to monitor changes in dimensions
      const resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
              // Call positionDropdownMenu on resize
              positionDropdownMenu();

              const { width, height } = entry.contentRect;

              setTimeout(function() {
                  const data = {
                      width: width,
                      height: height
                  };

                  window.parent.postMessage(data, "*"); // "*" allows sending to any origin, adjust as needed
              }, 100);
          });
      });

      if (element) {
          resizeObserver.observe(element);
      }
    });


    const currentUrl = window.location.href;
    const containsIframe = currentUrl.indexOf("iframe") !== -1;

    if(containsIframe || this.$route.query.customer) {
      if(this.$route.query.customer) {
        localStorage.setItem('parkkingcustomerselected', this.$route.query.customer);
      } else {
        localStorage.setItem('parkkingcustomerselected', 1);
      }
      
      localStorage.setItem('parkkingcustomertype', 1);
      localStorage.setItem('parkkingtoken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNGQ3OTlhZWJlM2YzNTIxOGNiZTdlNTQwNzQyODBkMWU4NDJkOGUyYjZiYWM1NjE4ZmY4N2U0ZmNlOWRjOGUzMzBjMGZkNWRjYjM0OWU5NzEiLCJpYXQiOjE3MTMyNzA2OTkuMTc0Mzg0LCJuYmYiOjE3MTMyNzA2OTkuMTc0MzkxLCJleHAiOjE3NDQ4MDY2OTkuMTcwNjg3LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.DvlRsQxqIwV1-ld3ycYhomf0Fz4lmo9naXl5438uIBReiMEewJOvp6QeB4v2L07xsO0IYTHDoVQjSxnJRrOvcQGb3Jy5clJLI6eTn7AP98aTvuK3QqeKqH-r33SnENvJ4ZdjmFseyfWKaLcZZyM_zVS-y6NXESSaAwCpS2wniTq55BnphU3UWZ1h4LE13VBagfXIU741opATHJBBhtNKUE9U5kRQSdr5zDD19R1kCPSEO18AFSjThTXhlRMuArRnmhY0LMkfAkh-7mWgnur5x9Y9oU4mL-OCfH9Rh_Sgk0j0aiB-NkLo7PURn8LWoVuefBF5ylfuUbhqY7h_jVvmmzla37qpm6KHf12ytNgiipMCCq_SSQocNYbdXi-xPpF5d0z4-v_Li9rEWpqcQMKXVjfWC9CnYFdUahSuLCA0Tz3-VRS0nBHD8s2OipPVtlnWXNPDfFcYIGDwOEeJj3GM6_8GMSvzTOUJGaJVXEsJ9kCQnEdw3QP0BZxvtGvxY2swf4JcfKNDO9depXVy_40gx36ORXz08ml2hL_Q7kPPPZ-MacQkvUR4S4nDIt81S9Y6FUp8V5aDMkytV4bjMKnTSPAGi8i13S-_7U0L5zQljosV1Wr_pv-8OTKBc1BFD8dd_TF3vAnoevKDWi_bu4HQaWpRjMv0w2h4HARhclyPaeY');
    } else {
      const currentUrl = window.location.href;
      const isLoginRoute = currentUrl.includes('login') || currentUrl.includes('azure') || currentUrl.includes('handlelogin');

      if (!isLoginRoute) {
        setTimeout(() => {
          this.setupLoginTimerCheck();
        }, 2000);
        this.setupPageVisibilityCheck();
      }

      if(!localStorage.getItem('parkkingcustomerselected') || localStorage.getItem('parkkingcustomerselected') == null || localStorage.getItem('parkkingcustomerselected') == '') {
        const currentUrl = window.location.href;

        // Check if the URL contains the words "login" or "logout"
        const containsLogin = currentUrl.includes('login');
        const containsLogout = currentUrl.includes('logout');

        // Example usage
        if (containsLogin || containsLogout) {
          console.log('Xp');
        } else {
          //window.location.href = "/logout";
        }
      }
    
      if(localStorage.getItem('selectedLanguage')) {
        this.$i18n.locale = localStorage.getItem('selectedLanguage');
      } else {
        localStorage.setItem('selectedLanguage', 'en');
        this.$i18n.locale = this.selectedLanguage;
      }
    }
  },
};
</script>
